export type ThemeMode = 'light' | 'dark';

const THEME_KEY = 'moiza.theme.v2';
const LEGACY_THEME_KEY = 'moiza.theme';

export function getStoredTheme(): ThemeMode {
  if (typeof window === 'undefined') return 'light';
  try {
    return window.localStorage.getItem(THEME_KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

function clearLegacyTheme() {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(LEGACY_THEME_KEY);
  } catch {
    // Ignore storage failures; theme application still works without persistence.
  }
}

export function applyTheme(theme: ThemeMode) {
  if (typeof document === 'undefined') return;
  if (theme === 'dark') {
    document.documentElement.dataset.theme = 'dark';
  } else {
    delete document.documentElement.dataset.theme;
  }
  document.documentElement.style.colorScheme = theme;
}

export function setStoredTheme(theme: ThemeMode) {
  applyTheme(theme);
  try {
    window.localStorage.setItem(THEME_KEY, theme);
    window.localStorage.removeItem(LEGACY_THEME_KEY);
  } catch {
    // Ignore storage failures; the in-memory document theme still applies.
  }
}

export function initTheme() {
  clearLegacyTheme();
  applyTheme(getStoredTheme());
}
